import { isImageItem, isVideoItem } from "./deliveryApi";

const IMAGE_EXTENSIONS = new Set([
    "jpg",
    "jpeg",
    "png",
    "webp",
    "gif",
    "heic",
    "heif",
    "tiff",
    "tif",
    "bmp",
    "avif",
]);

const TEXT_EXTENSIONS = new Set([
    "txt",
    "md",
    "markdown",
    "json",
    "csv",
    "log",
    "xml",
    "yaml",
    "yml",
    "ini",
    "conf",
    "cfg",
    "text",
]);

const VIDEO_EXTENSIONS = new Set(["mp4", "mov", "webm", "m4v"]);

export function getFileExtension(name) {
    const base = String(name || "").split("/").pop() || "";
    const dot = base.lastIndexOf(".");
    if (dot <= 0) {
        return "";
    }
    return base.slice(dot + 1).toLowerCase();
}

export function getDeliveryPreviewKind(file) {
    if (!file) {
        return null;
    }

    const ext = getFileExtension(file.name);
    const mimeType = file.mimeType || "";

    if (isImageItem(mimeType) || IMAGE_EXTENSIONS.has(ext)) {
        return "image";
    }

    if (mimeType === "application/pdf" || ext === "pdf") {
        return "pdf";
    }

    if (
        mimeType.startsWith("text/") ||
        mimeType === "application/json" ||
        mimeType === "application/xml" ||
        TEXT_EXTENSIONS.has(ext)
    ) {
        return "text";
    }

    if (isVideoItem(mimeType) || VIDEO_EXTENSIONS.has(ext)) {
        return "video";
    }

    return null;
}

export function isDeliveryPreviewable(file) {
    return getDeliveryPreviewKind(file) !== null;
}
